var map = {
	"./agentLogo.png": "6006",
	"./arr-right.png": "79e4",
	"./bad-active.png": "64db",
	"./bad.png": "8eac",
	"./customer-img.png": "f673",
	"./face.png": "257e",
	"./good-active.png": "5feb",
	"./good.png": "ade8",
	"./icon-img/add-icon.png": "90c7",
	"./icon-img/agent-avatar.png": "8b81",
	"./icon-img/back-icon.png": "7f54",
	"./icon-img/end-icon.png": "7bc5",
	"./icon-img/face-icon.png": "73a1",
	"./icon-img/file-icon.png": "3c41",
	"./icon-img/img-icon.png": "b7d8",
	"./icon-img/leaveMessage-icon.png": "82cb",
	"./icon-img/opinion-icon.png": "2065",
	"./icon-img/robot-agent-icon.svg": "c71c",
	"./icon-img/send-icon.png": "f875",
	"./icon-img/video-icon.png": "5e2f",
	"./icon-img/vioce-icon.png": "5490",
	"./icon-img/visitor-avatar.png": "3cd9",
	"./icon-reference.svg": "77c3",
	"./jianpan.png": "e6df",
	"./self-channel-icon/add.png": "f951",
	"./self-channel-icon/evaluation.svg": "01ef",
	"./self-channel-icon/face-active.png": "7c40",
	"./self-channel-icon/face.png": "f6f1",
	"./self-channel-icon/face.svg": "bda4",
	"./self-channel-icon/fold.svg": "dc81",
	"./self-channel-icon/pc-evaluation.png": "3cf6",
	"./self-channel-icon/pc-face.png": "6895",
	"./self-channel-icon/pc-fold.png": "9947",
	"./self-channel-icon/picture.svg": "db1b",
	"./self-channel-icon/video.svg": "98af",
	"./self-channel-icon/voice.png": "f6ff",
	"./topBack-satifaction.png": "0a36",
	"./voice.gif": "da20",
	"./voice.png": "38ff",
	"./wx/[666].svg": "8bd0",
	"./wx/[Emm].svg": "de19",
	"./wx/[OK].svg": "6ff1",
	"./wx/[举手].svg": "edd6",
	"./wx/[乒乓球].svg": "71c6",
	"./wx/[亲亲].svg": "5b11",
	"./wx/[便便].svg": "08d8",
	"./wx/[偷笑].svg": "92d4",
	"./wx/[傲慢].svg": "6a24",
	"./wx/[元气满满].svg": "c4db",
	"./wx/[再见].svg": "1c6f",
	"./wx/[冷汗].svg": "2ca2",
	"./wx/[凋谢].svg": "dcd1",
	"./wx/[刀].svg": "dcb5",
	"./wx/[加油].svg": "c863",
	"./wx/[勾引].svg": "328b",
	"./wx/[发].svg": "b6a1",
	"./wx/[发呆].svg": "a45d",
	"./wx/[发怒].svg": "2cd8",
	"./wx/[发抖].svg": "4507",
	"./wx/[发财].svg": "6cc8",
	"./wx/[可怜].svg": "1664",
	"./wx/[可爱].svg": "6657",
	"./wx/[右哼哼].svg": "dfe7",
	"./wx/[叹气].svg": "d381",
	"./wx/[吃瓜].svg": "74f5",
	"./wx/[合十].svg": "0097",
	"./wx/[吐].svg": "fc38",
	"./wx/[吓].svg": "9553",
	"./wx/[呲牙].svg": "cbcc",
	"./wx/[咒骂].svg": "f6b3",
	"./wx/[咖啡].svg": "e36a",
	"./wx/[哇].svg": "e466",
	"./wx/[哈欠].svg": "c591",
	"./wx/[啤酒].svg": "aabf",
	"./wx/[嘘].svg": "0c29",
	"./wx/[嘴唇].svg": "62fc",
	"./wx/[嘿哈].svg": "37c9",
	"./wx/[囧].svg": "74df",
	"./wx/[困].svg": "0c6f",
	"./wx/[在吗].svg": "582e",
	"./wx/[坏笑].svg": "a30b",
	"./wx/[大兵].svg": "c48b",
	"./wx/[大哭].svg": "e59b",
	"./wx/[天啊].svg": "c301",
	"./wx/[太阳].svg": "cf6c",
	"./wx/[失望].svg": "3747",
	"./wx/[奋斗].svg": "8c01",
	"./wx/[奸笑].svg": "d9c0",
	"./wx/[好的].svg": "ca65",
	"./wx/[委屈].svg": "f3ed",
	"./wx/[害羞].svg": "542a",
	"./wx/[尴尬].svg": "70bd",
	"./wx/[左哼哼].svg": "ddac",
	"./wx/[庆祝].svg": "0f3b",
	"./wx/[弱].svg": "a07f",
	"./wx/[强].svg": "c98d",
	"./wx/[得意].svg": "709d",
	"./wx/[微笑].svg": "a3a6",
	"./wx/[心碎].svg": "7eca",
	"./wx/[快哭了].svg": "395c",
	"./wx/[恐惧].svg": "ec59",
	"./wx/[悠闲].svg": "3e12",
	"./wx/[惊恐].svg": "b1a3",
	"./wx/[惊讶].svg": "2034",
	"./wx/[愉快].svg": "e591",
	"./wx/[憨笑].svg": "890c",
	"./wx/[打脸].svg": "571c",
	"./wx/[抓狂].svg": "252b",
	"./wx/[抓狂备份].svg": "1745",
	"./wx/[抠鼻].svg": "c05b",
	"./wx/[抱拳].svg": "8a9d",
	"./wx/[拥抱].svg": "616e",
	"./wx/[拳头].svg": "7e79",
	"./wx/[捂脸].svg": "af3f",
	"./wx/[捂脸哭].svg": "5866",
	"./wx/[握手].svg": "7897",
	"./wx/[摊手].svg": "61e2",
	"./wx/[撇嘴].svg": "12c0",
	"./wx/[擦汗].svg": "47b2",
	"./wx/[敲打].svg": "f2f0",
	"./wx/[无语].svg": "ef15",
	"./wx/[旺柴].svg": "3d35",
	"./wx/[晕].svg": "e1d2",
	"./wx/[月亮].svg": "2f89",
	"./wx/[机智].svg": "5cb2",
	"./wx/[比耶].svg": "cca1",
	"./wx/[汗].svg": "95e9",
	"./wx/[流汗].svg": "44d1",
	"./wx/[流泪].svg": "0365",
	"./wx/[炸弹].svg": "f865",
	"./wx/[烟花].svg": "12f4",
	"./wx/[爆竹].svg": "1012",
	"./wx/[爱心].svg": "4178",
	"./wx/[猪头].svg": "129b",
	"./wx/[玫瑰].svg": "3819",
	"./wx/[生病].svg": "aadf",
	"./wx/[疑问].svg": "7fd0",
	"./wx/[白眼].svg": "bee0",
	"./wx/[皱眉].svg": "e430",
	"./wx/[睡].svg": "c0c0",
	"./wx/[破涕为笑].svg": "50ad",
	"./wx/[礼物].svg": "d2c3",
	"./wx/[社会社会].svg": "f80f",
	"./wx/[福].svg": "98ac",
	"./wx/[笑脸].svg": "c8a5",
	"./wx/[篮球].svg": "6d0c",
	"./wx/[篮球备份].svg": "3569",
	"./wx/[米饭].svg": "5c44",
	"./wx/[糗大了].svg": "3def",
	"./wx/[红包].svg": "2aee",
	"./wx/[翻白眼].svg": "d27b",
	"./wx/[耶].svg": "11d5",
	"./wx/[胜利].svg": "3c414",
	"./wx/[脸红].svg": "f79c",
	"./wx/[色].svg": "2ac1",
	"./wx/[苦涩].svg": "e706",
	"./wx/[菜刀].svg": "1c4a",
	"./wx/[蛋糕].svg": "4d15",
	"./wx/[衰].svg": "01b9",
	"./wx/[裂开].svg": "99c9",
	"./wx/[西瓜].svg": "de14",
	"./wx/[让我看看].svg": "eb36",
	"./wx/[调皮].svg": "aa90",
	"./wx/[足球].svg": "a0c1",
	"./wx/[跳跳].svg": "ccc3",
	"./wx/[转圈].svg": "adaf",
	"./wx/[鄙视].svg": "de2f",
	"./wx/[酷].svg": "5ece",
	"./wx/[闪电].svg": "68e5",
	"./wx/[闭嘴].svg": "5146",
	"./wx/[阴险].svg": "1b17",
	"./wx/[难过].svg": "a5ee",
	"./wx/[饥饿].svg": "4461",
	"./wx/[骷髅].svg": "e364",
	"./wx/[鼓掌].svg": "3223",
	"./yinbo.gif": "6947",
	"./yun/0.png": "1d6d",
	"./yun/1.png": "2d2f",
	"./yun/10.png": "900e",
	"./yun/11.png": "c3ac",
	"./yun/12.png": "83d4",
	"./yun/13.png": "b054",
	"./yun/14.png": "3325",
	"./yun/15.png": "28c1",
	"./yun/16.png": "d5a1",
	"./yun/2.png": "5aa0",
	"./yun/3.png": "222f",
	"./yun/4.png": "6b65",
	"./yun/5.png": "e9ea",
	"./yun/6.png": "fa6b",
	"./yun/7.png": "38ce",
	"./yun/8.png": "5166",
	"./yun/9.png": "542e",
	"./yuyin.png": "46c2",
	"./语音.png": "ee4c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";